import './index.css';

function ItemListTableUser({user, editUser, deleteUser}) {

  return (
    <>
      <div className="item_list_table">
        <div className="header_item_list">
          <div className="header_item_name">{user.name}</div>
          <div className="header_item_part">{user.department}</div>
        </div>
        <div className="body_item_list">
          <div className="row">
            <div className="col-4 title_item">Mail:</div>
            <div className="col-8 content_item">{user.email}</div>
            <div className="col-4 title_item">SDT Nhân viên:</div>
            <div className="col-8 content_item">{user.phone}</div>
            <div className="col-4 title_item">Vai trò:</div>
            <div className="col-8 content_item">{user.role}</div>
            <div className="col-4 title_item">Dự án:</div>
            <div className="col-8 content_item">{user.project}</div>
            <div className="col-4 title_item">Ngày cập nhật:</div>
            <div className="col-8 content_item ">{user.update_date}</div>
            <div className="col-4 title_item">Người cập nhật:</div>
            <div className="col-8 content_item">{user.update_by}</div>
          </div>
          <hr />
          <div className="action_button">
            <div className="row">
              <div className="col-6 title_item pt-0">
                Sửa / Xóa:
              </div>
                <div className="col-6 action_button_item">
                <img src="./dashboard/edit.png" alt="  " onClick={editUser}/>
                <span style={{fontSize: '30px'}}> / </span>
                <img src="./dashboard/delete_2.png" alt="  " onClick={deleteUser}/>
              </div>
            </div>
          </div>
        </div>
      </div>
            
    </>
  );
}

export default ItemListTableUser;